import { createComponentClickedEvent, track } from "./base"

export const tabClicked = ({
  tabText,
  currentTab,
}: {
  tabText: string
  currentTab: string
}) => {
  track(
    createComponentClickedEvent({
      current_screen: "Unknown",
      component_type: "tab_menu_option",
      component_function: `switch to tab: ${tabText}`,
      action_taken: "tab pressed",
      component_text: tabText,
      clicked_values: {
        current_tab: currentTab,
      },
    })
  )
}
